import React, { useState } from 'react';
import { Box, TextField, Button, Collapse, MenuItem, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from 'react-i18next';
import { todoAPI } from '../services/api';
import fields from './todoFields.module.css';
import styles from './TodoForm.module.css';

const TodoForm = ({ areaId, onTodoAdded, open, onToggle }) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [urgency, setUrgency] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [dueDateFocused, setDueDateFocused] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim()) return;

    setLoading(true);
    try {
      await todoAPI.create(title, description, areaId, urgency, dueDate);
      setTitle('');
      setDescription('');
      setUrgency('');
      setDueDate('');
      if (onToggle) onToggle();
      if (onTodoAdded) onTodoAdded();
    } catch (error) {
      console.error('Error creating todo:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Collapse in={open}>
      <Box
        component="form"
        onSubmit={handleSubmit}
        className={`${fields.card} ${styles.formBox}`}
      >
        <TextField
          fullWidth
          size="small"
          placeholder={t('task.titlePlaceholder')}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          autoFocus
          className={`${fields.field} ${fields.mb1}`}
        />
        <TextField
          fullWidth
          size="small"
          placeholder={t('task.descriptionPlaceholder')}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          multiline
          rows={2}
          className={`${fields.field} ${fields.mb1}`}
        />
        <Box className={fields.editRow}>
          <TextField
            fullWidth
            size="small"
            select
            label={t('task.urgencyLabel')}
            value={urgency}
            onChange={(e) => setUrgency(e.target.value)}
            SelectProps={{ MenuProps: { disableScrollLock: true } }}
            className={fields.field}
          >
            {['', 'LOW', 'MEDIUM', 'HIGH'].map((v) => (
              <MenuItem key={v} value={v} className={fields.menuItem}>
                {t(`task.urgency.${(v || 'none').toLowerCase()}`)}
              </MenuItem>
            ))}
          </TextField>
          <Box className={fields.dueWrap}>
            <TextField
              fullWidth
              size="small"
              label={t('task.dueDateLabel')}
              type={dueDate || dueDateFocused ? 'date' : 'text'}
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
              onFocus={() => setDueDateFocused(true)}
              onBlur={() => setDueDateFocused(false)}
              InputLabelProps={{ shrink: dueDate || dueDateFocused ? true : undefined }}
              className={fields.field}
            />
            {dueDate && (
              <IconButton size="small" onClick={() => setDueDate('')} className={fields.clearDateBtn}>
                <CancelIcon className={fields.clearDateIcon} />
              </IconButton>
            )}
          </Box>
        </Box>
        <Box className={fields.editActions}>
          <Button
            type="submit"
            size="small"
            disabled={loading || !title.trim()}
            className={fields.saveBtn}
          >
            {loading ? t('task.adding') : t('task.add')}
          </Button>
          <Button
            size="small"
            onClick={onToggle}
            disabled={loading}
            className={fields.cancelBtn}
          >
            {t('common.cancel')}
          </Button>
        </Box>
      </Box>
    </Collapse>
  );
};

export default TodoForm;
